import React from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import { convertDateToString, convertStringToDate, getDateString } from 'components/Canvas/renderer/utils/timeHelpers'
import { DatePicker, TimePicker } from 'material-ui'
import FormLanguage from 'components/forms/FormLanguage'
import FormLabel from 'components/labels/FormLabel'
import styled from 'styled-components'

const CountDownWrapper = styled.div`
  .custom-field {
    width: calc(100% - 10px) !important;
  }
`

const CountDownContent = ({
  value,
  value: {
    date,
    time = '00:00:00',
    timeoutMessage = {},
  },
  onChange,
}) => {
  const dateValue = getDateString(date)
  const handleChangeContent = (val, key) => onChange(updateObject(value, { [key]: val }))
  return (
    <CountDownWrapper>
      <FormLabel>End Time</FormLabel>
      <DatePicker
        hintText="End Date"
        mode="landscape"
        onChange={(_, val) => {
          handleChangeContent(convertDateToString(val)('YYYY-MM-DD'), 'date')
        }}
        defaultDate={convertStringToDate(dateValue, 'YYYY-MM-DD')}
        style={{
          display: 'inline-block',
          width: 'calc(50% - 10px)',
          overflow: 'hidden',
          marginRight: '10px',
        }}
      />
      <TimePicker
        hintText="End Time"
        mode="landscape"
        onChange={(_, val) => handleChangeContent(convertDateToString(val)('HH:mm:ss'), 'time')}
        defaultTime={convertStringToDate(time, 'HH:mm:ss')}
        style={{
          display: 'inline-block',
          width: 'calc(50% - 10px)',
          overflow: 'hidden',
          marginLeft: '10px',
        }}
      />
      <FormLanguage
        label="Timeout Message"
        value={timeoutMessage}
        onChange={(val) => handleChangeContent(val, 'timeoutMessage')}
      />
    </CountDownWrapper>
  )
}

CountDownContent.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
}
CountDownContent.defaultProps = {
  value: {},
  onChange: () => {},
}

export default CountDownContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/countDown/CountDownContent.js